module.exports = __webpack_public_path__ + "img/newBasic.955b75da.png";